import { render, staticRenderFns } from "./LocalisedPatternsTab.vue?vue&type=template&id=8babd068"
import script from "./LocalisedPatternsTab.vue?vue&type=script&lang=js"
export * from "./LocalisedPatternsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports